import React, { CSSProperties } from 'react';
import { CheckboxProps } from '@material-ui/core/Checkbox';
import { GreenCheck } from './CustomCheckboxes';

type Props = {
  label?: string;
  icon?: JSX.Element;
  strikethrough?: boolean;
  labelStyle?: CSSProperties;
  /**
   * Aligns the checkbox with the label's first line when the label wraps, instead of centering it
   * against all the lines. Assumes a 24px line height, as the tree views use.
   */
  alignTop?: boolean;
} & CheckboxProps;

export default function LabelWithCheckbox(props: Props) {
  const { label, icon, strikethrough, labelStyle, alignTop, style, ...rest } = props;

  return (
    <div style={{ display: 'flex', alignItems: alignTop ? 'flex-start' : 'center', ...style }}>
      <GreenCheck
        size="small"
        onClick={(e) => e.stopPropagation()}
        style={{
          padding: 0,
          // A small checkbox is 20px tall: 2px centers it on a 24px first line.
          margin: alignTop ? '2px 4px 0px 0px' : '0px 4px 0px 0px',
          flexShrink: 0,
        }}
        {...rest}
      />
      <span style={{ textDecoration: strikethrough ? 'line-through' : 'initial', ...labelStyle }}>
        {label}
      </span>
      {icon}
    </div>
  );
}
